import { IFormActualsTargetsSettings } from 'legacy/lut/classes/models/partner360/IFormActualsTargetsSettings'
import { ITranslationFactors } from 'legacy/lut/classes/models/partner360/ITranslationFactors'
import { Dispatch, SetStateAction } from 'react'

import { IJBPPlanningItem } from '../../models/IJBPPlanning'
import { PLANNING_BY_FY_FQ } from '../config'
import { IFieldProps } from '../models/IFieldProps'

import { getFieldName } from './getFieldName'
import { setItemValuesUniversal } from './setItemValuesUniversal'

interface IProps {
  items: IJBPPlanningItem[]
  reservedItems: IJBPPlanningItem[]
  setting: IFormActualsTargetsSettings
  fieldProps: IFieldProps
  fy: number
  type: 'actuals' | 'targets' | 'quota' | 'nosplit'
  setTargetsItems: Dispatch<SetStateAction<IJBPPlanningItem[]>>
  setActualsItems: Dispatch<SetStateAction<IJBPPlanningItem[]>>
  translationFactors?: ITranslationFactors[] | null
}

export const setQuarterByFYTotal = ({
  items,
  reservedItems,
  setting,
  fieldProps,
  fy,
  type,
  setTargetsItems,
  setActualsItems,
  translationFactors,
}: IProps) => {
  const data = [...items]

  const fieldName = getFieldName(fieldProps)
  const cat = setting.Category

  // Filtered on Top level: PartnerId, ProgramTypes, Category, IsActuals, IsTarget, IsQuota
  const fyData = items.filter(
    (el) =>
      el.ProgramTypes === setting.ProgramType &&
      el.Category === setting.Category &&
      el.SubCategory === setting.SubCategory &&
      el.L3Category === setting.L3Category &&
      el.FYear === fy &&
      el.FQuarter === PLANNING_BY_FY_FQ
  )

  if (fyData.length >= 1) {
    // Get Total from FY
    const total = Number(fyData[0][fieldName] || 0)

    let isEmpty = true

    for (let fq = 1; fq < PLANNING_BY_FY_FQ; fq++) {
      const qData = reservedItems.filter(
        (el) =>
          el.ProgramTypes === setting.ProgramType &&
          el.Category === setting.Category &&
          el.SubCategory === setting.SubCategory &&
          el.L3Category === setting.L3Category &&
          el.FYear === fy &&
          el.FQuarter === fq
      )
      if (qData.length >= 1) {
        const quarterValue = Number(qData[0][fieldName] || 0)
        if (quarterValue) {
          isEmpty = false
        }
      }
    }

    const isSoB = fieldProps.isSoB
    // For SoB: copy FY in all FQ if all FQ was empty
    // For Currency: FQ = FY / 4
    if (!isSoB || isEmpty) {
      // Set Quarter
      for (let fq = 1; fq < PLANNING_BY_FY_FQ; fq++) {
        const qData = items.filter(
          (el) =>
            el.ProgramTypes === setting.ProgramType &&
            el.Category === setting.Category &&
            el.SubCategory === setting.SubCategory &&
            el.L3Category === setting.L3Category &&
            el.FYear === fy &&
            el.FQuarter === fq
        )
        if (qData.length >= 1) {
          const quarterValue = Number(total / 4)

          const value = isSoB ? total : quarterValue
          const newItem = setItemValuesUniversal(
            qData[0],
            value,
            fieldProps,
            cat,
            false,
            translationFactors
          )

          const idx = items.indexOf(qData[0])
          data.splice(idx, 1, newItem)
        }
      }

      if (type === 'actuals') {
        setActualsItems([...data])
      } else {
        setTargetsItems([...data])
      }
    }
  }

  return data
}
